import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import constants from "../../utils/constants";

const AboutUs = () => {
  const theme = useTheme();
  const { about_us } = constants;

  return (
    <Box sx={{ width: "100%", mt: 4, overflow: "hidden", px: 3 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.primary.main, mb: 1 }}>
        {about_us.title}
      </Typography>

      {/* Intro Note */}
      <Typography variant="body1" sx={{ color: theme.palette.heading_color.main, mb: 2, fontStyle: "italic", fontWeight: "bold" }}>
        {about_us.note}
      </Typography>

      {/* Vision Section */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {about_us.heading_vision}
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.heading_color.main }}>
          {about_us.vision_note}
        </Typography>
      </Box>

      {/* Mission Section */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {about_us.heading_mission}
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.heading_color.main }}>
          {about_us.mission_note.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
        </Typography>
      </Box>

      {/* Products Section */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {about_us.heading_products}
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.heading_color.main, mb: 1 }}>
          {about_us.products_note}
        </Typography>

        <Box sx={{ pl: 2 }}>
          {[1, 2, 3, 4].map((i) => (
            <Box key={i} sx={{ mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.secondary.main }}>
                {about_us[`product${i}`]}
              </Typography>
              <Typography variant="body1" sx={{ color: theme.palette.heading_color.main }}>
                {about_us[`product${i}_description`]}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Partners Section */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {about_us.heading_partners}
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.heading_color.main }}>
          {about_us.partners_note.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
        </Typography>
      </Box>

      {/* History Section */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold", color: theme.palette.heading_color.main }}>
          {about_us.heading_history}
        </Typography>
        <Typography variant="body1" sx={{ color: theme.palette.heading_color.main }}>
          {about_us.history_note.split("\n").map((line, index) => (
                <React.Fragment key={index}>
                {line}
                <br />
                </React.Fragment>
            ))}
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutUs;
